import doubleMetaphone from 'double-metaphone';
import { distance } from 'fastest-levenshtein';

import { SupportedLanguages } from '../../../../voice-response-command/vrc-audio-metadata/supported-languages';
import { normalizeSpeechResult } from '../normalize-speech-result';

export const isPhoneticMatch = (detectedText: string, expectedText: string): boolean => {
  const normalizedDetected = normalizeSpeechResult(detectedText, SupportedLanguages.en);
  const normalizedExpected = normalizeSpeechResult(expectedText, SupportedLanguages.en);

  /**
   * We do not allow strings with short lengths because they can create false positives.
   * This also helps avoid matching common stopwords like "is", "am", "are", "you", etc.
   */
  if (normalizedDetected.length < 4 || normalizedExpected.length < 4) {
    return false;
  }

  const detectedCodes = doubleMetaphone(normalizedDetected).filter(Boolean);
  const expectedCodes = doubleMetaphone(normalizedExpected).filter(Boolean);

  if (
    detectedCodes.length === 0 ||
    expectedCodes.length === 0 ||
    !detectedCodes.some((code: string) => expectedCodes.includes(code))
  ) {
    return false;
  }

  const maxLength = Math.max(normalizedDetected.length, normalizedExpected.length);
  const similarity = 1 - distance(normalizedDetected, normalizedExpected) / maxLength;
  return similarity >= 0.6;
};
